import { render, staticRenderFns } from "./MantenimientoItem.vue?vue&type=template&id=a5e1b06c&scoped=true"
import script from "./MantenimientoItem.vue?vue&type=script&lang=js"
export * from "./MantenimientoItem.vue?vue&type=script&lang=js"
import style0 from "./MantenimientoItem.vue?vue&type=style&index=0&id=a5e1b06c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e1b06c",
  null
  
)

export default component.exports